import requests from './httpService';

const EnquiryService = {
  submitPublicEnquiry(schooleId, body) {
    return requests.post(`/enquiry/public/${schooleId}`, body);
  },

  checkPublicMobile(schooleId, mobile) {
    return requests.get(`/enquiry/public/${schooleId}/check-mobile`, { params: { mobile } });
  },

  listEnquiriesForSchool(schooleId) {
    return requests.get(`/enquiry/admin/${schooleId}`);
  },

  deleteEnquiry(schooleId, enquiryId) {
    return requests.delete(`/enquiry/admin/${schooleId}/${enquiryId}`);
  },

  // Optional custom fields (up to 5) the school adds to its public enquiry form.
  getFormConfig(schooleId) {
    return requests.get(`/enquiry/public/${schooleId}/form-config`);
  },

  saveFormConfig(schooleId, customFields) {
    return requests.put(`/enquiry/admin/${schooleId}/form-config`, { customFields });
  },
};

export default EnquiryService;

